import { datetime, date, time } from './datetime'
import { phone, phoneURI } from './phone'
import price from './price'
import { zip } from './zip'

export * from './datetime'
export * from './phone'
export { default as price } from './price'
export * from './zip'

const strFormatter = {
  datetime,
  date,
  time,
  phone,
  phoneURI,
  price,
  zip,
}
export default strFormatter
